// removed by extract-text-webpack-plugin
module.exports = {"Checkout":"Checkout__Checkout__a29AN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Checkout/Checkout.css
// module id = 153
// module chunks = 0